module.exports = "<div id=\"fb-root\"></div>\r\n\r\n\r\n<app-header></app-header>\r\n<simple-notifications [options]=\"notificationsOptions\"></simple-notifications>\r\n<router-outlet></router-outlet>\r\n<app-footer ></app-footer>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/wamp64/www/Uclics/demo/angular/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main